// This constant is used for Test A/B purposes.
export const TIME_WAITING_FOR_GOOGLE_OPTIMIZE_REDIRECTION = 3000;
